import React, { useState } from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { DataTable } from '../../../../common/components';
import { openModal } from '../../../../common/components/Modal/ModalRedux';
import { refreshData } from '../../../../common/components/DataTable/redux/dataTableActions';
import UpdateTransactionModal from '../UpdateTransactionModal';
import { hasPermission } from '../../../auth/redux/authActions';
import { connect } from 'react-redux';
import formatDate from '../../../../helpers/formatDate';

const formatReference = (cell) => {
  try {
    const parsedReference = JSON.parse(cell);
    if (typeof parsedReference === 'string' || typeof parsedReference === 'number') {
      return parsedReference;
    }
    return `${parsedReference?.transactionId ?? ''} / ${parsedReference.tokenId ?? ''}`;
  } catch (e) {
    return cell;
  }
};

const formatNumber = (cell) => {
  return cell.toFixed(2);
};

const formatSource = (cell) => {
  if (cell === 'payment gateway') {
    return 'card';
  }

  return cell;
};

const CustomerTransactions = ({
  customerId,
  onOpenModal,
  onRefreshData,
  hideSizePerPage,
  disableMinHeight,
}) => {
  const [transaction, setTransaction] = useState({});

  const handleRowClick = (row) => {
    setTransaction(row);
    if (hasPermission('account.edit') && row && row.reference && row.amount > 0) {
      onOpenModal('transactionForm');
    }
  };

  const refreshList = () => {
    onRefreshData('transactions');
  };

  return (
    <>
      <DataTable
        hideSizePerPage={hideSizePerPage}
        source={'/policies/transactions'}
        autoFilter={customerId}
        autoFilterType="filter[customer]"
        name="transactions"
        disableMinHeight={disableMinHeight}
        showTotal
        onRowSelect={handleRowClick}
      >
        <TableHeaderColumn dataField="id" isKey hidden />

        <TableHeaderColumn
          dataField="reference"
          dataSort
          width={'30%'}
          dataFormat={formatReference}
        >
          Reference
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="currency"
          dataSort={false}
          width={'10%'}
          dataAlign="center"
        >
          Currency
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="amount"
          dataSort={false}
          dataAlign="right"
          dataFormat={formatNumber}
          width={'20%'}
        >
          Amount
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="source"
          dataSort={false}
          dataFormat={formatSource}
          width={'20%'}
          dataAlign="center"
        >
          Source
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="created_at"
          dataFormat={formatDate}
          dataSort
          width={'10%'}
        >
          Transacted At
        </TableHeaderColumn>

        <TableHeaderColumn dataField="status" width={'10%'}>
          Status
        </TableHeaderColumn>
      </DataTable>

      <UpdateTransactionModal
        hidden
        label={'Refund Transaction'}
        callback={refreshList}
        refundTransaction={transaction}
      />
    </>
  );
};

export default connect(
  null,
  {
    onOpenModal: openModal,
    onRefreshData: refreshData,
  },
)(CustomerTransactions);
